// [INATIV-BOT] modal do no "Inatividade"
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
  root: { display: "flex", flexWrap: "wrap" },
  campo: { marginBottom: 14 },
  dica: { fontSize: 12, color: "#555", marginBottom: 14, lineHeight: "18px" },
}));

const PADRAO = {
  remindMinutes: "10",
  remindMessage: "Ainda está aí? É só responder para continuar.",
  finalMinutes: "20",
  action: "close",
  finalMessage: "Encerramos o atendimento por falta de resposta. Se precisar, é só chamar novamente.",
  queueId: "",
};

const FlowBuilderAddInactivityModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [form, setForm] = useState(PADRAO);
  const [filas, setFilas] = useState([]);

  useEffect(() => {
    if (open === "edit") {
      const d = (data && data.data) || {};
      setForm({
        remindMinutes: d.remindMinutes !== undefined ? String(d.remindMinutes) : "0",
        remindMessage: d.remindMessage || "",
        finalMinutes: d.finalMinutes !== undefined ? String(d.finalMinutes) : "0",
        action: d.action || "none",
        finalMessage: d.finalMessage || "",
        queueId: d.queueId ? String(d.queueId) : "",
      });
      setActiveModal(true);
    } else if (open === "create") {
      setForm(PADRAO);
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  useEffect(() => {
    if (!activeModal) return;
    (async () => {
      try {
        const { data: lista } = await api.get("/queue");
        setFilas(Array.isArray(lista) ? lista : (lista && lista.queues) || []);
      } catch (e) {
        setFilas([]);
      }
    })();
  }, [activeModal]);

  const set = (campo) => (e) => {
    const valor = e && e.target ? e.target.value : e;
    setForm((f) => ({ ...f, [campo]: valor }));
  };

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const num = (v) => {
    const n = parseInt(v, 10);
    return n > 0 ? n : 0;
  };

  const handleSave = () => {
    const fila = filas.find((q) => String(q.id) === String(form.queueId));
    const dados = {
      remindMinutes: num(form.remindMinutes),
      remindMessage: (form.remindMessage || "").trim(),
      finalMinutes: num(form.finalMinutes),
      action: form.action,
      finalMessage: (form.finalMessage || "").trim(),
      queueId: form.action === "queue" && form.queueId ? Number(form.queueId) : null,
      queueName: form.action === "queue" && fila ? fila.name : "",
    };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data && data.data), ...dados } });
    } else if (open === "create") {
      onSave(dados);
    }
    handleClose();
  };

  const faltaFila = form.action === "queue" && !form.queueId;

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth maxWidth="sm" scroll="paper">
        <DialogTitle>{open === "create" ? "Adicionar inatividade" : "Editar inatividade"}</DialogTitle>
        <DialogContent dividers>
          <Typography className={classes.dica}>
            Vale daqui pra frente no fluxo, até outro nó Inatividade. Quando o bot pergunta algo (Input, Menu,
            Coletar arquivos) e o cliente para de responder, o MFlux manda o lembrete; se continuar sem
            resposta, faz a ação final. Se o cliente responder, o fluxo segue de onde parou. Coloque 0 nos dois
            tempos para desligar o controle a partir deste ponto.
          </Typography>
          <TextField
            className={classes.campo}
            label="Lembrete após (minutos sem resposta)"
            variant="outlined"
            type="number"
            fullWidth
            value={form.remindMinutes}
            onChange={set("remindMinutes")}
            helperText="0 = sem lembrete"
          />
          <TextField
            className={classes.campo}
            label="Texto do lembrete"
            variant="outlined"
            multiline
            rows={2}
            fullWidth
            value={form.remindMessage}
            onChange={set("remindMessage")}
          />
          <TextField
            className={classes.campo}
            label="Ação final após mais (minutos)"
            variant="outlined"
            type="number"
            fullWidth
            value={form.finalMinutes}
            onChange={set("finalMinutes")}
            helperText="Contados a partir do lembrete (ou da pergunta, se não houver lembrete). 0 = sem ação final"
          />
          <TextField
            className={classes.campo}
            select
            label="Ação final"
            variant="outlined"
            fullWidth
            value={form.action}
            onChange={set("action")}
          >
            <MenuItem value="close">Encerrar o atendimento (sem NPS)</MenuItem>
            <MenuItem value="queue">Transferir para uma fila</MenuItem>
            <MenuItem value="none">Nenhuma (só lembrete)</MenuItem>
          </TextField>
          {form.action === "queue" && (
            <TextField
              className={classes.campo}
              select
              label="Fila"
              variant="outlined"
              fullWidth
              value={form.queueId}
              onChange={set("queueId")}
              error={faltaFila}
              helperText={faltaFila ? "Escolha a fila" : ""}
            >
              {filas.map((q) => (
                <MenuItem key={q.id} value={String(q.id)}>
                  {q.name}
                </MenuItem>
              ))}
            </TextField>
          )}
          {form.action !== "none" && (
            <TextField
              className={classes.campo}
              label="Mensagem final (opcional)"
              variant="outlined"
              multiline
              rows={2}
              fullWidth
              value={form.finalMessage}
              onChange={set("finalMessage")}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            {i18n.t("contactModal.buttons.cancel")}
          </Button>
          <Button color="primary" variant="contained" onClick={handleSave} disabled={faltaFila}>
            {open === "create" ? "Adicionar" : "Editar"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddInactivityModal;
